import { twMerge } from 'tailwind-merge';
import { classes, styles } from './utils';

export type PercentageBarProps = {
  className?: string;
  fillClassName?: string;
  fillColor?: string;
  width: number;
};

export default function PercentageBar({
  className,
  fillClassName,
  fillColor,
  width,
}: PercentageBarProps) {
  return (
    <div className={twMerge(classes.track, className)}>
      <div
        style={styles.fill(width, fillColor)}
        className={twMerge(
          classes.fill,
          fillClassName ?? (!fillColor && classes.defaultFill)
        )}
      />
    </div>
  );
}
